(function(){
  if (window.__spFunnelShapeInit) return;
  window.__spFunnelShapeInit = true;

  var KEY = 'sp_funnel_shape';
  var TTL_MS = 30 * 60 * 1000;

  // Setting shape value -> the value the diamond catalog filters on. The
  // settings say "Old Mine" (owner rename 2026-07-09) but the diamond DB's
  // canonical_shape for that group is still "Antique Cuts" (the umbrella of
  // Old Mine / Old Moval / Old Oval / Old Euro / European / Old Miner), which
  // is what the lab-diamonds pill's data-shape + the API filter use. Bridge
  // here so an Old Mine setting still lands on the antique-cut diamonds.
  var TO_DIAMOND = { 'Old Mine': 'Antique Cuts' };

  // ---- Helpers ----------------------------------------------------------------
  function normalizeShape(raw){
    if (!raw) return '';
    var s = String(raw).trim();
    // Strip common suffixes ("Round Cut" -> "Round") and trim whitespace.
    s = s.replace(/\s+cut$/i, '').trim();
    if (!s) return '';
    // Title-case "Long Cushion" / "Dutch Marquise" etc.
    return s.split(/\s+/).map(function(w){
      return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    }).join(' ');
  }

  function readSelectedShape() {
    // 1) Radio input — Stienhardt setting PDP uses <input type=radio name="Shape">
    //    (bare name, not options[Shape]). Also check legacy patterns.
    var radio = document.querySelector(
      'input[type="radio"][name="Shape"]:checked,' +
      'input[type="radio"][name="shape"]:checked,' +
      'input[type="radio"][name="options[Shape]"]:checked,' +
      'input[type="radio"][name="options[shape]"]:checked'
    );
    if (radio && radio.value) return normalizeShape(radio.value);

    // 2) Select element with shape option
    var sel = document.querySelector('select[name="Shape"], select[name="shape"], select[name="options[Shape]"], select[name="options[shape]"]');
    if (sel && sel.value) return normalizeShape(sel.value);

    // 3) Variant-id lookup against ProductVariants JSON. Most reliable on
    //    Stienhardt setting PDPs because the variant ID is always in the URL.
    try {
      var vid = (new URLSearchParams(location.search)).get('variant');
      if (vid) {
        var blob = document.getElementById('ProductVariants');
        if (blob && blob.textContent) {
          var arr = JSON.parse(blob.textContent);
          var match = arr.find(function(v){ return String(v.id) === String(vid); });
          if (match) {
            // Title is "Metal / Shape" — pick the option that matches a known shape.
            var known = ['Round','Princess','Oval','Cushion','Emerald','Pear','Radiant','Marquise','Heart','Asscher','Long Cushion','French Marquise','Dutch Marquise','Portuguese','Elongated Hexagon','Moval','Old Mine','Antique Cuts'];
            // Check option1/2/3 fields first
            for (var oi = 0; oi < 3; oi++) {
              var key = 'option' + (oi + 1);
              var v = match[key];
              if (v) { for (var k = 0; k < known.length; k++) if (v === known[k]) return known[k]; }
            }
            // Fallback: scan the variant title
            var t = (match.title || '').toLowerCase();
            for (var k2 = 0; k2 < known.length; k2++) {
              if (t.indexOf(known[k2].toLowerCase()) !== -1) return known[k2];
            }
          }
        }
      }
    } catch (_) {}

    // 4) Active swatch / button with data-value
    var active = document.querySelector('[data-option-name="Shape"] .is-active, [data-option-name="Shape"] .active, [data-option-name="shape"] .is-active');
    if (active) {
      var av = active.getAttribute('data-value') || active.textContent;
      if (av) return normalizeShape(av);
    }

    // 5) Page heading / product title fallback (last resort).
    var knownShapes = ['Round','Princess','Oval','Cushion','Emerald','Pear','Radiant','Marquise','Heart','Asscher','Long Cushion','French Marquise','Dutch Marquise','Portuguese','Elongated Hexagon','Moval','Old Mine','Antique Cuts'];
    var title = (document.querySelector('h1, .product-single__title') || {}).textContent || '';
    var lowerT = ' ' + title.toLowerCase() + ' ';
    for (var j = 0; j < knownShapes.length; j++) {
      if (lowerT.indexOf(' ' + knownShapes[j].toLowerCase() + ' ') !== -1) return knownShapes[j];
    }
    return '';
  }

  function saveShape(shape) {
    if (!shape) return;
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ shape: shape, t: Date.now() }));
    } catch (_) {}
  }
  function readSavedShape() {
    try {
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return '';
      var obj = JSON.parse(raw);
      if (!obj || !obj.shape) return '';
      if (Date.now() - (obj.t || 0) > TTL_MS) {
        try { sessionStorage.removeItem(KEY); } catch (_) {}
        return '';
      }
      return obj.shape;
    } catch (_) { return ''; }
  }
  function clearSavedShape() { try { sessionStorage.removeItem(KEY); } catch (_) {} }

  // Infer shape from the current collection URL path. The Stienhardt theme
  // categorises setting products under shape-specific collections like
  //   /collections/round-cut-diamond-engagement-rings/
  //   /collections/princess-cut-diamond-engagement-rings/
  // so the shape is encoded in the collection handle. Style-based collections
  // (hidden-halo, solitaire, etc.) return '' so we don't misclassify them.
  function inferShapeFromCollectionPath() {
    var path = location.pathname + location.search;
    var MAP = [
      ['round-cut','Round'],['princess-cut','Princess'],['oval-cut','Oval'],
      ['cushion-cut','Cushion'],['emerald-cut','Emerald'],['pear-cut','Pear'],
      ['radiant-cut','Radiant'],['marquise-cut','Marquise'],['heart-cut','Heart'],
      ['asscher-cut','Asscher'],['long-cushion','Long Cushion'],
      ['french-marquise','French Marquise'],['dutch-marquise','Dutch Marquise'],
      ['portuguese','Portuguese'],['elongated-hexagon','Elongated Hexagon'],
      ['moval','Moval'],['old-mine','Old Mine'],['antique-cut','Antique Cuts']
    ];
    for (var i = 0; i < MAP.length; i++) {
      if (path.indexOf('/collections/' + MAP[i][0]) !== -1) return MAP[i][1];
    }
    // ?filter.v.option.shape=Princess or ?shape=Princess
    var m = path.match(/[?&](?:filter\.v\.option\.shape|shape)=([^&#]+)/);
    if (m) return normalizeShape(decodeURIComponent(m[1].replace(/\+/g, ' ')));
    return '';
  }

  // ---- Setting PDP hook (and shape-collection sidecar) ------------------------
  // 1) Click on #choosethissetting → look for a chosen shape in the page form,
  //    falling back to the collection URL the page belongs to.
  // 2) Passive: whenever the user is on a shape-named collection (e.g.
  //    /collections/princess-cut-diamond-engagement-rings/), proactively stash
  //    that shape — so even if they navigate to lab-diamonds via the mega
  //    menu or some other path that doesn't fire #choosethissetting, we still
  //    propagate.
  function captureShapeNow() {
    var s = readSelectedShape();
    if (!s) s = inferShapeFromCollectionPath();
    if (s) saveShape(s);
  }
  document.addEventListener('click', function(e){
    var btn = e.target && e.target.closest && e.target.closest('#choosethissetting');
    if (!btn) return;
    captureShapeNow();
  }, true);
  // Passive sidecar — runs immediately if we're on a shape-named collection
  // page or a shape-filtered collection page.
  var passive = inferShapeFromCollectionPath();
  if (passive) saveShape(passive);

  // ---- Lab-diamonds: inject ?shape + mark body for shape-collapse -------------
  if (/\/collections\/(lab-diamonds|diamonds)/.test(location.pathname)) {
    var alreadyHasShape = false;
    try { alreadyHasShape = !!(new URL(location.href)).searchParams.get('shape'); } catch (_) {}

    // Track whether the shape came from the setting-funnel handoff (clicked
    // "Choose This Setting" on a setting PDP → shape stashed in sessionStorage
    // → we inject it into the URL here). Only in that case should the shape
    // filter start collapsed — bookmarks / direct pastes / shape-filter clicks
    // within lab-diamonds itself should keep the filter expanded so the user
    // can swap shapes easily.
    var fromFunnel = false;

    if (!alreadyHasShape) {
      var saved = readSavedShape();
      // Translate the setting-side label into the diamond catalog's filter
      // value (Old Mine -> Antique Cuts); identity for every other shape.
      var savedDiamond = (TO_DIAMOND[saved] || saved);
      if (saved) {
        try {
          var u = new URL(location.href);
          u.searchParams.set('shape', savedDiamond);
          history.replaceState(null, '', u.toString());
          alreadyHasShape = true;
          fromFunnel = true;
        } catch (_) {}

        // The search template reads ?shape= ONCE, at parse time — which has
        // already happened by the time this (deferred) script runs, so the
        // replaceState above updates the URL bar but NOT the live filter
        // state. Activate the filter the same way a shopper would: click the
        // matching shape pill once the search has built it. The pill click
        // updates state + re-runs the search + syncs the URL itself.
        (function clickPillWhenReady(tries){
          var pill = document.querySelector('.sd-shape[data-shape="' + savedDiamond + '"]');
          if (!pill) {
            // fallback: match by visible pill text. Accept BOTH the diamond
            // value and the setting label (the pill renders the display label,
            // e.g. "Old Mine", while its data-shape is "Antique Cuts").
            var all = document.querySelectorAll('.sd-shape');
            for (var i = 0; i < all.length; i++) {
              var t = (all[i].textContent || '').trim().split('\n')[0].trim();
              if (t === saved || t === savedDiamond) { pill = all[i]; break; }
            }
          }
          if (pill) {
            if (!pill.classList.contains('active')) pill.click();
            return;
          }
          if (tries < 100) setTimeout(function(){ clickPillWhenReady(tries + 1); }, 100);
        })(0);
      }
    }

    // Mark body ONLY if the shape was handed off from a setting PDP — that's
    // the funnel context where the user has already committed to a shape and
    // doesn't need the picker in their face.
    if (fromFunnel) {
      var addClass = function(){ if (document.body) document.body.classList.add('sd-shape-prefilled'); };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', addClass);
      } else {
        addClass();
      }
    }
    clearSavedShape();
  }
})();
